'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _insertNewline = require('./insertNewline');

var _insertNewline2 = _interopRequireDefault(_insertNewline);

var _richTextConstants = require('../richText/richTextConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = function (editorState) {
  return (0, _insertNewline2.default)(editorState, _richTextConstants.STYLE_COMMANDS.UNSTYLED);
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/customRichUtils/insertUnstyledNewline.js
// module id = 1716
// module chunks = 0